






































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { AgreementDocument, PRIVACY_POLICY, USER_AGREEMENT } from './agreement-content';

@Component
export default class AgreementConsent extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  dialogVisible = false;
  activeDocument: AgreementDocument | null = null;

  get dialogTitle() {
    return this.activeDocument === USER_AGREEMENT ? '星云平台用户协议' : '星云平台隐私政策';
  }

  openAgreement(type: 'user' | 'privacy') {
    this.activeDocument = type === 'user' ? USER_AGREEMENT : PRIVACY_POLICY;
    this.dialogVisible = true;
  }
}
